export default __webpack_public_path__ + "static/media/uiuxImage.9a512e5c.svg";